import axios from 'axios'
import global from '@/utils/global.js'
import store from '@/store/index.js'
let filterRESTful = ['/user/login'];
export function fetch(url, param, config, judge) {
  let _config = config || {
    headers: {
      loginType: 2,
      Authorization: ''
    }
  };
  let _param = param || {};
  let _keyWord = url.split('/');
  let flag = filterRESTful.some((item) => {
    return item === _keyWord[_keyWord.length - 1]
  });
  // 在名单中的添加额外入参
  _config.headers.loginType = 2;
  if (!flag) {
    _param['deleteFlag'] = 0;
    _config.headers.Authorization = store.getters.token
  }
  // 补足接口的“/”
  url = url.substr(0, 1) == '/' ? url : '/' + url;
  return new Promise((resolve, reject) => {
    if (judge) {
      axios.get(global.baseURL + url, {params:_param,headers: _config.headers}).then(response => {
        resolve(response.data)
      }, err => {
        console.error('接口报错！', err)
      });
    } else {
      axios.post(global.baseURL + url, _param, _config).then(response => {
        resolve(response.data)
      }, err => {
        console.error('接口报错！', err)
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/axios/index.js